import React, { Fragment } from "react";
import {
  TBody,
  THead,
  Table,
  TableWrapper,
  Td,
  Th,
  Tr,
} from "Components/Common/Table/TableT1";
import {
  TypographyT43,
  TypographyT44,
  TypographyT45,
  TypographyT46,
  TypographyT47,
} from "Components/Common/Typography/index";
import Moment from "moment";
import { ReactComponent as DownloadIconT1 } from "Icons/downloadIconT1.svg";
import { ReactComponent as FileSearchIcon } from "Icons/fileSearchIcon.svg";
import { ReactComponent as PencilIcon } from "Icons/pencilIcon.svg";
import styled from "@emotion/styled";
import { FlexWrapperT2 } from "Components/Common/Wrapper/FlexWrapper";
import { IconButtonT1 } from "Components/Common/Button/index";
import TooltipT1 from "Components/Common/ToolTip/TooltipT1";
import AdditionalFilesTable from "./AdditionalFilesTable";
const InprogressAndCompletedTable = (props) => {
  const {
    selectedTab,
    inprogressShipmentDetailsList,
    completedShipmentDetailsList,
    handleOnclickForMoreInformationPopup,
    handleOnClickDownloadContainerBlTrackingFile,
    handleOnClickAdditionalFiles,
  } = props;

  const getData = () => {
    if (selectedTab === 2) {
      return inprogressShipmentDetailsList;
    } else if (selectedTab === 3) {
      return completedShipmentDetailsList;
    }
  };
  return (
    <Fragment key={selectedTab}>
      <TableWrapper>
        <Table>
          <THead>
            <Tr>
              <Th>SL No.</Th>
              <Th>Trip Created Date & Time</Th>
              <Th>Container No.</Th>
              <Th>Origin Port</Th>
              <Th>ETD (Origin Port)</Th>
              <Th>ATD(Actual Time of Dept.)</Th>
              <Th>Destination Port</Th>
              <Th>ETA (Origin Port)</Th>
              <Th>Revised Actual Time of Arr.</Th>
              <Th>ATA(Actual Time of Arr.)</Th>
              <Th>Current Location</Th>
              <Th>Status</Th>
              <Th>Action</Th>
            </Tr>
          </THead>
          <TBody>
            {getData().map((ele, ind) => {
              const currentEvent = [];
              (ele.events || []).map((cEvent) => {
                if (Moment(cEvent.date).valueOf() <= Moment().valueOf()) {
                  currentEvent.push(cEvent);
                }
              });
              return (
                <Fragment key={ind}>
                  <Tr>
                    <Td>
                      <TypographyT43>{ind + 1}</TypographyT43>
                    </Td>
                    <Td>
                      <TypographyT43>
                        {!!ele.created &&
                          Moment(ele.created).format("DD/MM/YYYY HH:mm:ss")}
                      </TypographyT43>
                    </Td>
                    <Td>
                      <TypographyT44>{ele.container_number}</TypographyT44>
                      <TypographyT45
                        onClick={() => {
                          handleOnClickAdditionalFiles(ele);
                        }}
                      >
                        Additional Docs
                      </TypographyT45>
                      {/* <TooltipT1>
                        <AdditionalFilesTable />
                      </TooltipT1> */}
                    </Td>
                    <Td>
                      <TypographyT46>
                        {`${(ele.from || {}).from}, ${
                          (ele.from || {}).state
                        }, ${(ele.from || {}).country}`}
                      </TypographyT46>
                    </Td>
                    <Td>
                      <TypographyT43>
                        {(ele.from || {}).date &&
                          Moment((ele.from || {}).date).format(
                            "DD/MM/YYYY HH:mm:ss"
                          )}
                      </TypographyT43>
                    </Td>
                    <Td>
                      <TypographyT43>
                        {((ele.from || {}).actual &&
                          Moment((ele.from || {}).date).format(
                            "DD/MM/YYYY HH:mm:ss"
                          )) ||
                          "-"}
                      </TypographyT43>
                    </Td>
                    <Td>
                      <TypographyT46>
                        {`${(ele.to || {}).from}, ${(ele.to || {}).state}, ${
                          (ele.to || {}).country
                        }`}
                      </TypographyT46>
                    </Td>
                    <Td>
                      <TypographyT43>
                        {(ele.to || {}).date &&
                          Moment((ele.to || {}).date).format(
                            "DD/MM/YYYY HH:mm:ss"
                          )}
                      </TypographyT43>
                    </Td>
                    <Td>
                      <TypographyT43>
                        {!!ele.revised_date &&
                          Moment(ele.revised_date).format(
                            "DD/MM/YYYY HH:mm:ss"
                          )}
                      </TypographyT43>
                    </Td>
                    <Td>
                      <TypographyT43>
                        {((ele.to || {}).actual &&
                          Moment((ele.to || {}).date).format(
                            "DD/MM/YYYY HH:mm:ss"
                          )) ||
                          "-"}
                      </TypographyT43>
                    </Td>
                    <Td>
                      <TypographyT46>
                        {currentEvent[currentEvent.length - 1].name}
                      </TypographyT46>
                    </Td>
                    <Td>
                      <TypographyT47>{ele.status}</TypographyT47>
                    </Td>
                    <Td>
                      <FlexWrapperT2>
                        <IconButtonT1
                          onClick={() => {
                            handleOnclickForMoreInformationPopup(ele);
                          }}
                        >
                          <FileSearchIcon />
                        </IconButtonT1>
                        {selectedTab === 2 && (
                          <IconButtonT1>
                            <PencilIcon />
                          </IconButtonT1>
                        )}
                        <IconButtonT1
                          onClick={() => {
                            handleOnClickDownloadContainerBlTrackingFile(
                              ele.container_number
                            );
                          }}
                        >
                          <DownloadIconT1 />
                        </IconButtonT1>
                      </FlexWrapperT2>
                    </Td>
                  </Tr>
                </Fragment>
              );
            })}
          </TBody>
        </Table>
      </TableWrapper>
    </Fragment>
  );
};

export default InprogressAndCompletedTable;
